import React from "react";

import { Text } from "@UI/Components/Text/Text";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { OfferPrice } from "@Shared/Components/OfferPrice/OfferPrice";
import { useFeatureFlag } from "@Libs/GrowthBook/hooks/useFeatureFlag";
import { components } from "@api/schema";
import { IAppCurrency } from "@App/types";
import messages from "../messages";

interface IServiceOfferForPrice {
  rateCents: number;
  serviceFeesCents?: number;
  expenses?: { amountCents: number }[];
  expensesFeesCents?: number;
  billingUnit: components["schemas"]["serviceOffer"]["billingUnit"];
  rateCurrency: IAppCurrency;
  rateType: components["schemas"]["serviceOffer"]["rateType"];
}

interface ICandidateOfferPriceProps {
  serviceOffer: IServiceOfferForPrice;
  isSubscribed: boolean;
}

export const CandidateOfferPrice = ({
  serviceOffer,
  isSubscribed,
}: ICandidateOfferPriceProps) => {
  const isActivationRateEnabled = useFeatureFlag("new-activation-rate");

  if (!isActivationRateEnabled) return null;

  if (serviceOffer.rateType === "estimate") {
    const color = isSubscribed ? "pink.500" : "gray.800";

    return (
      <Text as="h5" fontSize="lg" fontWeight="bold" color={color} m="0" textDecoration="underline" cursor="pointer">
        <FormattedMessage {...messages["serviceRequest.offerDetail.visitForQuote"]} />
      </Text>
    );
  }

  return (
    <Text as="h5" fontWeight="bold" fontSize="lg" m="0">
      <OfferPrice
        rateCents={serviceOffer.rateCents}
        serviceFeesCents={serviceOffer.serviceFeesCents}
        expenses={serviceOffer.expenses}
        expensesFeesCents={serviceOffer.expensesFeesCents}
        billingUnit={serviceOffer.billingUnit}
        currency={serviceOffer.rateCurrency}
        isSubscribed={isSubscribed}
        colorScheme="candidateCard"
        textDecoration="underline"
      />
    </Text>
  );
};
